/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type InternalGetUnverifiedMemberPendingInvitesPathParams = NonNullable<
  operations['internalGetUnverifiedMemberPendingInvites']['parameters']['path']
>;

export interface Input extends InternalGetUnverifiedMemberPendingInvitesPathParams {
  apiVersion?: string;
}

export async function internalGetUnverifiedMemberPendingInvites(
  { apiVersion, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/account/signup/{token}/pending-invites', {
    params: { path },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
